export default __webpack_public_path__ + "static/media/legal.7b6c3649.jpg";